import { Button, LoadingButton } from '@olxbr/ds-core'
import { Modal } from '@olxbr/ds-web'
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { getMaskedValue } from '../../../util/PhonePattern'

const StyledFlex = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`

const PhoneText = styled.span`
  font-weight: var(--font-weight-bold);
`

export const ConfirmResendCodeModal = ({ onConfirm, closeModal, isOpen, isSubmitting, phone }) => {
  return (
    <Modal preventCloseOnOutsideClick open={isOpen} size="small" closeCallback={closeModal}>
      <StyledFlex>
        <span className="typo-title-small mb-3">Reenviar código</span>
        <span className="typo-body-medium mb-4">
          Deseja reenviar o código para o número{' '}
          <PhoneText>{getMaskedValue(phone).pretty}</PhoneText>?
        </span>
        <LoadingButton
          onClick={onConfirm}
          className="w-full mb-1"
          isLoading={isSubmitting}
          disabled={isSubmitting}
        >
          Reenviar
        </LoadingButton>
        <Button variant="link" className="w-full" onClick={closeModal} disabled={isSubmitting}>
          Cancelar
        </Button>
      </StyledFlex>
    </Modal>
  )
}

ConfirmResendCodeModal.propTypes = {
  onConfirm: PropTypes.func,
  isOpen: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  closeModal: PropTypes.func,
  phone: PropTypes.string,
}
